// extracted by mini-css-extract-plugin
export default {"wrapper":"TextAreaBlock_wrapper__UX4X0"};